import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import { vMaska } from "maska"


import ui from '@/assets/ui'

import '@/assets/css/template_styles.css'
import '@/assets/css/style.css'

const app = createApp(App)

ui.forEach(component => {
    app.component(component.name, component)
})

app.directive("maska", vMaska)

app.use(store).use(router).mount('#app')
